module.exports = __webpack_public_path__ + "static/media/inf_45og46.fcc90fae.mp3";